import React, {useState} from 'react'
import {gql, useMutation,useQuery} from "@apollo/client";
import '../App.css';

const GET_SALIDA = gql `
query getSalidas{
  getSalidas{
    _id
   fecha
   concepto
   cantidad
  } 
}`

const GET_ENTRADA = gql `
query getEntradas{
  getEntradas{
    _id
   fecha
   concepto
   cantidad
  } 
}`

function Total() {
    const { loading: loadingSalidas, error: errorSalidas, data: dataSalidas } = useQuery(GET_SALIDA);
    const { loading: loadingEntradas, error: errorEntradas, data: dataEntradas } = useQuery(GET_ENTRADA);
  
    if (loadingSalidas || loadingEntradas) return <p>Esperando resultados...</p>;
    if (errorSalidas || errorEntradas) return <p>Error</p>;
  
    const totalSalidas = dataSalidas?.getSalidas?.reduce((acumulador, salida) => acumulador + salida.cantidad, 0) || 0;
    const totalEntradas = dataEntradas?.getEntradas?.reduce((acumulador, entrada) => acumulador + entrada.cantidad, 0) || 0;
    const total = totalEntradas - totalSalidas;
  

    
    return (
      <div className="card card-total">
      <h1>Total</h1>
      <h1>{total}</h1>
      </div>
    );
  }
  

export default Total